"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelgerundo": {
    "7f81759c": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "barona": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c81e7b16": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-reghinera": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8828f89d": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "casella": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16a00b5d": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "castellina": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1502c62b": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "colombarone": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "247c3d5f": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "de-preti": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cee57125": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "faruffina": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dd3f54e2": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "indumiera": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7aa9b98c": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "skipSearch": false
    }],
    "portina": [{
      "hkey": "68118a5a",
      "slug": "castelgerundo",
      "name": "Castelgerundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;